import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useJwt } from "react-jwt";
import Sidebar from "../components/Sidebar";
import { CreateBrand, GetProductStatus } from "../apiconfig/authService";
import { ToastContainer, toast } from "react-toastify"; // Import toastify
import "react-toastify/dist/ReactToastify.css"; // Import styles for toastify

function AddBrand(props) {
  const navigate = useNavigate();
  const { isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setProductViewMessage = props.setMessage;
  const [brandname, setBrandname] = useState("");
  const [categoryStatusid, setCategoryStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);

  const handleStatusIdChange = (e) => {
    setCategoryStatusid(Number(e.target.value));
  };

  const handleBrandnameChange = (e) => setBrandname(e.target.value);

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!brandname) throw new Error("Brand name is required.");

      const response = await CreateBrand(
        { brandname, statusid: categoryStatusid }, // Pass categoryStatusid
        localStorage.getItem("accessToken")
      );

      if (response.status === 200) {
        setProductViewMessage(response.data.message);
        toast.success("Brand added successfully!");
        navigate("/brand");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.error || "An error occurred. Please try again later."
      );
      window.scrollTo(0, 0);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Brand Name</h1>
        </div>

        <div className="personal-info tab-pane active storetab">
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <label htmlFor="brandName">Brand Name</label>
            <input
              type="text"
              value={brandname}
              onChange={handleBrandnameChange}
              className="form-control custom-input my-2"
              id="brandName"
              placeholder="Enter Brand Name"
            />
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3">
            <label htmlFor="floatingInput">Status</label>
            <select
              className="form-select custom-input my-2"
              onChange={handleStatusIdChange}
              value={categoryStatusid}
            >
              {statusData?.map((item) => (
                <option key={item.statusid} value={item.statusid}>
                  {item.status}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group col-sm-12 col-lg-12 mb-3 ">
            <button
              type="submit"
              onClick={handleSubmitClick}
              className="btn btn-primary save-btn text-uppercase px-4 my-3"
            >
              Add
            </button>
          </div>
        </div>
        <hr />
      </div>

      {/* Toast container */}
      <ToastContainer />
    </div>
  );
}

export default AddBrand;
